"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const order_entity_1 = require("./order.entity");
const order_line_item_entity_1 = require("./order-line-item.entity");
const shipment_entity_1 = require("./shipment.entity");
const shipment_line_item_entity_1 = require("./shipment-line-item.entity");
const inventory_stock_entity_1 = require("../inventory/inventory-stock.entity");
const orders_service_1 = require("./orders.service");
const orders_controller_1 = require("./orders.controller");
const customers_module_1 = require("../customers/customers.module");
const notifications_module_1 = require("../notifications/notifications.module");
let OrdersModule = class OrdersModule {
};
exports.OrdersModule = OrdersModule;
exports.OrdersModule = OrdersModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([order_entity_1.Order, order_line_item_entity_1.OrderLineItem, shipment_entity_1.Shipment, shipment_line_item_entity_1.ShipmentLineItem, inventory_stock_entity_1.InventoryStock]),
            customers_module_1.CustomersModule,
            notifications_module_1.NotificationsModule,
        ],
        providers: [orders_service_1.OrdersService],
        controllers: [orders_controller_1.OrdersController],
        exports: [orders_service_1.OrdersService],
    })
], OrdersModule);
